import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import "./Home.css";
import LeftColumn from "../components/LeftColumn";
import Content from "../components/Content";

const Home = () => {
  return (
    <>
      <div className="page-bg">
        <div className="container">
          <Header />
          <div className="content__wrapper">
            <LeftColumn />
            <div className="space-scrollbar">
              <Content />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
